Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "AddOrRemoveAdminRole859202464",
  {"header":"AddOrRemoveAdminRole859202464--header","memberName":"AddOrRemoveAdminRole859202464--memberName","description":"AddOrRemoveAdminRole859202464--description","list":"AddOrRemoveAdminRole859202464--list","root":"AddOrRemoveAdminRole859202464--root"},
  "",
  1,
  "AddOrRemoveAdminRole859202464"
);

